<template>
  <div class="empty-state">
    <div class="empty-state__icon" v-if="$slots.icon">
      <slot name="icon" />
    </div>
    <div class="empty-state__text">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: "暂无数据",
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/variable.scss";

.empty-state {
  width: 100%;
  padding: $space-lg 0;
  text-align: center;
  color: $color-text-sub;
  font-size: $font-size-body;

  &__icon {
    margin-bottom: $space-sm;
  }

  &__text {
    line-height: 1.6;
  }
}
</style>


